// process.env pass by webpack

export default {
	domain: 'https://api.daoyidh.com/ptp',
	contextRoot: '/',
};
